import React, { useContext, useEffect, useRef, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { EnterOfSettlementsBalancesDto } from "../../../../dtos/documents/EnterOfSettlementsBalances/EnterOfSettlementsBalancesDto";
import { FormProvider, Resolver, useForm } from "react-hook-form";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFTextAreaInput } from "../../../Shared/NewForms/NFTextAreaInput";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { NFLookupCurrency } from "../../../Shared/NewForms/NFlookupCurrency";
import { NFLookupVendor } from "../../../Shared/NewForms/NFLookupVendor";
import { EnterOfSettlementsBalancesModel } from "../../../../models/Documents/EnterOfSettlementsBalances/EnterOfSettlementsBalancesModel";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import * as XLSX from "xlsx";
import { NFLookupArapWriteOffs } from "../../../Shared/NewForms/NFLookupArapWriteOffs";
import { NFLookupCustomer } from "../../../Shared/NewForms/NFLookupCustomer";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import EnterOfSettlementsBalancesDetailSkeleton from "./EnterOfSettlementsBalancesDetailSkeleton";
import { AppEntities } from "../../../../config/entities";
import { importFromExcel } from "../../../../helpers/SaveObjectToExcel";
import { saveObjectToExcel } from "../../../../helpers/SaveObjectToExcel";
import { EnterOfSettelementBalancesDetailFooter } from "./EnterOfSettelementBalancesDetailFooter";

interface IProps {
  model: EnterOfSettlementsBalancesDto | null;
  modelUpdatedEvent: (newModel: EnterOfSettlementsBalancesDto) => void;
}

export const EnterOfSettlementsBalancesDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Enter Of Settlements Balances");

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<EnterOfSettlementsBalancesModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  const watchProducts = watch("enterOfSettlementsBalanceGoods");

  useEffect(() => {
    console.log(model);
    register("enterOfSettlementsBalanceGoods");
    if (model) {
      setValue("id", model.id);
      setValue("documentNumber", model.documentNumber);
      setValue("documentDate", model.documentDate);
      setValue("companyId", model.companyId);
      setValue("operationType", model.operationType);
      setValue("comment", model.comment);
      setValue("createdDate", model.createdDate);
      setValue("enterOfSettlementsBalanceGoods", model.enterOfSettlementsBalanceGoods);
    }
  }, [model]);

  useEffect(() => {
    console.log(watchProducts);
  }, [watchProducts]);

  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: EnterOfSettlementsBalancesModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  if (!model) {
    return (
      <>
        <EnterOfSettlementsBalancesDetailSkeleton />
      </>
    );
  }

  const exportToExcel = () => {
    const data = {
      ...model
    };
    const documentInfo = {
      title: AppEntities.EnterOfSettlementsBalances.title,
      number: model.documentNumber,
      date: model.documentDate
    };
    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };
  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Products"} />
        <NFTab title={"Additional"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        <DocumentModalViewHeader
          onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))}
          onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))}
          onClose={closeHandler}
          onCancel={cancelHandler}
          handleUploadFile={handleUploadFile}
          exportToExcel={exportToExcel}
          fileName={fileName}
          setFileName={setFileName}
        />

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Document #"} disabled fieldName={"documentNumber"} />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Document Date"} fieldName={"documentDate"} required={true} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupCompany fieldName={"companyId"} title={"Company"} required={true} />
            </Col>
            <Col sm={6}>
              <NFIntInput fieldName={"operationType"} title={"Operation type"} />
            </Col>
          </Row>
        </NFTabContainer>

        <NFTabContainer index={1} currentIndex={tabIndex}>
          <NFormTable fieldArray={"enterOfSettlementsBalanceGoods"}>
            <NFLookupProduct fieldName={"productVendorCode"} title={"productVendorCode"} width={200} />
            <NFDateInput title="Payment Date" fieldName="paymentDate" />
            <NFIntInput fieldName={"advanceLocal"} title={"advanceLocal"} />
            <NFIntInput fieldName={"advanceMan"} title={"advanceMan"} />
            <NFIntInput fieldName={"price"} title={"price"} width={100} />
            <NFLookupCurrency fieldName={"currencyId"} title={"Currency"} width={200} />
            <NFIntInput fieldName={"advance"} title={"Advance"} />
            <NFLookupArapWriteOffs fieldName={"arApObjectId"} title={"ArAp Object id"} width={200} />
            <NFIntInput fieldName={"debt"} title={"Debt"} width={100} />
            <NFIntInput fieldName={"debtLocal"} title={"Debt Local"} width={100} />
            <NFIntInput fieldName={"debtMan"} title={"Debt man"} />
            <NFTextInput title="ArAp object type" fieldName="arApObjectType" />
            <NFLookupCustomer title="Customer" fieldName="customerId" width={200} />
            <NFLookupVendor title="Vendor" fieldName="vendorId" width={200} />
          </NFormTable>
        </NFTabContainer>

        <NFTabContainer index={2} currentIndex={tabIndex}>
          <Row>
            <Col sm={12}>
              <NFTextAreaInput fieldName={"comment"} title={"Comment"} required={false} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Created User"} fieldName={"createdUser"} disabled={true} />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Created Date"} fieldName={"createdDate"} disabled={true} />
            </Col>
          </Row>
        </NFTabContainer>
      </div>
      <EnterOfSettelementBalancesDetailFooter/>
    </FormProvider>
  );
};
